// @ts-check
import React, { createContext, useEffect, useState } from "react"
import { THEME_MODES } from "../consts/themes.consts"

/** @typedef {import("./ThemeContext.context.types.d.ts").context} context */

export const ThemeContext = createContext(
  /** @type {context} */
  ({
    theme: "dark",
    changeTheme: () => {},
  })
)

export function ThemeContextProvider({ children }) {
  const [theme, setTheme] = useState(/** @type {context["theme"]} */ ("dark"))
  useEffect(() => {
    const localTheme = /** @type {"dark" | "light" | null} */ (
      localStorage.getItem("aikaTheme")
    )
    if (localTheme) {
      setTheme(localTheme)
    }
  }, [])

  useEffect(() => {
    if (!window.navigator.onLine) return
    const themeTag = document.getElementById("theme-css")
    const layoutTag = document.getElementById("layout-css")
    // @ts-ignore
    themeTag.href = `/assets/custom/${theme}/theme.css`
    // @ts-ignore
    layoutTag.href = `/assets/custom/${theme}/layout.css`
    localStorage.setItem("aikaTheme", theme)
    document.documentElement.style.setProperty("color-scheme", theme)
  }, [theme])

  /**
   * @param {'dark' | 'light' | undefined} toTheme
   */
  const changeTheme = (toTheme = undefined) => {
    if (toTheme) {
      setTheme(toTheme)
      localStorage.setItem("theme", toTheme)
    } else {
      const newTheme = theme === THEME_MODES.LIGHT ? "dark" : "light"
      setTheme(newTheme)
      localStorage.setItem("theme", newTheme)
    }
  }
  return (
    <>
      <ThemeContext.Provider value={{ changeTheme, theme }}>
        {children}
      </ThemeContext.Provider>
    </>
  )
}
